// 所有已过时的老版接口
export function getObsoleteApi(key) {

	var apis = [];

	// 获取团队日结
	apis['GET_TEAM_HISTORY'] = '?controller=gameinfo&action=teamhistoryall&ischild=1&star_date=$&end_date=$&username=$&p=$';

	// 获取个人日工资
	apis['GET_PERSONAL_DAILY_WAGE'] = '?controller=compact&action=user&starttime=$&endtime=$&pstatus=$&p=$&orderby=$&sort=$'

	// 获取个人账变
	apis['GET_PERSONAL_SELFBANK_RECORD'] = '?controller=report&action=selfbankreport&date=4&ordertype=$&status=$&starttime=$&endtime=$&p=$&userid=$'

	// 注册用户
	apis['REGISTER'] = '$';

	// 代理注册下级用户
	apis['REGISTER_BY_AGENT'] = 'user/adduser?1=1';

	// 注册用户名校验
	apis['CHECK_USERNAME_FOR_REGISTER'] = 'user/usercheck?username=$';

	// 获取团队首页数据
	apis['GET_TEAM_USER_LIST'] = '?controller=user&action=list&frame=show&flag=search&bank_min=$&bank_max=$&username=$&userid=$&p=$&orderby=$&sort=$';

	// 推广链接
	apis['AGENT_REG_URL'] = 'user/marketing?1=1';

	// 获取下级返点
	apis['GET_FOLLOWER_REBET'] = '?controller=user&action=upedituser&uid=$'

	// 设置下级返点
	apis['SET_FOLLOWER_REBET'] = '?controller=user&action=upedituser';

	// 获取下级日工资
	apis['GET_TEAM_SALARY'] = '?controller=compact&action=teamsalary&username=$&starttime=$&endtime=$&pstatus=$&p=$&orderby=$&sort=$'

	// 检测安全密码是否正确
	apis['CHECK_SECURITY_PASS'] = '?controller=security&action=checkpass';

	// 获取下级真人反水
	apis['GET_LIVE_TEAM_SALARY'] = 'compact/teamsalarylive?starttime=$&endtime=$&username=$&pstatus=$&p=$&orderby=$&sort=$';

	// 获取下级转账限额
	apis['GET_TRANSFER_LIMIT'] = '?controller=user&action=saveup&uid=$&check=$'

	// 提交下级转账
	apis['SUBMIT_TEAM_GROUP_TRANSFER'] = '?controller=user&action=saveup';

	// 获取真人下级契约  和 获取创建契约的下级用户
	apis['GET_TEAM_COMPACT_LIVE'] = '?controller=compact&action=teamcompactlive&username=$&pstatus=$&p=$'

	// 获取投注记录
	apis['GET_LOTTERY_BET_HIS'] = '?controller=gameinfo&action=newgamelist&starttime=$&endtime=$&lotteryid=$&methodid=$&username=$&ischild=$&p=$';

	// 获取真人下级契约详情 type=1日工资下级契约详情  type=2 真人下级契约详情   
	apis['GET_TEAM_COMPACT_DETAIL'] = '?controller=compact&action=ajaxhubsport&tag=contract&userid=$&type=$'

	// 校验密保问题
	apis['CHECK_SECURITY_QUESTION'] = '?controller=user&action=checkquestion';

	// 获取投注详情
	apis['GET_BET_DETAIL'] = '?controller=gameinfo&action=newgamedetail&id=$&times=$&issue=$'

	// 获取彩票报表概要信息【含盈亏】
	apis['GET_WINLOSS_SUMMERY'] = '?controller=gameinfo&action=historyteamlottery&star_date=$&end_date=$&username=$&ischild=$&p=$&orderby=$'

	// 创建下级契约 type=1 日工资  type =2  真人  type=3 体育
	apis['CREATE_COMPACT'] = '?controller=compact&action=create&type=$';

	// 多选删除站内信
	apis['DELETE_MULTI_MESSAGE'] = '?controller=user&action=messages&tag=deleteselect';

	// 删除所有站内信
	apis['DELETE_ALL_MESSAGE'] = '?controller=user&action=messages&tag=deleteall';

	// 获取历史追号列表
	apis['GET_TRACE_HIS'] = '?controller=report&action=traceinfo&starttime=$&endtime=$&lotteryid=$&methodid=$&p=$'

	// 修改提款密码
	apis['UPDATE_WITHDRAWAL_PASS'] = '?controller=user&action=retrievesepas';

	// 获取历史追号详情
	apis['GET_TRACE_HIS_DETAIL'] = '?controller=gameinfo&action=taskdetail&id=$'

	// 获取彩种返点信息列表
	apis['GET_LOTTERY_REBET_INFO'] = '?controller=user&action=userset'

	// 修改契约
	apis['REVISE_COMPACT'] = '?controller=compact&action=update&type=$'

	// 停止追号
	apis['STOP_TRACE_BET'] = '?controller=gameinfo&action=canceltask';

	// 获取日工资下级契约
	apis['GET_TEAM_COMPACT_DAILY'] = '?controller=compact&action=teamcompact&username=$&pstatus=$&p=$';

	// 获取第三方游戏报表
	apis['GET_THRID_PARTY_GAME_REPORT_BYID'] = 'gameinfo/eprofitloss?starttime=$&endtime=$&userid=$&cid=$&p=$&ordername=$&order=$'
	apis['GET_THRID_PARTY_GAME_REPORT_BYNAME'] = 'gameinfo/eprofitloss?starttime=$&endtime=$&username=$&cid=$&p=$&ordername=$&order=$'

	// 获取第三方投注记录
	apis['GET_THRID_PARTY_BET_REPORT'] = 'gameinfo/livetigerprojects?startDate=$&endDate=$&userid=$&platform=$&isgetdate=1&page_size=20&p=$'

	// 获取常见问题
	apis['GET_Q_A'] = '?controller=help&action=answer';

	// 获取玩法介绍
	apis['GET_METHOD_Q_A'] = '?controller=help&action=playinfo'

	// 获取下级体育契约
	apis['GET_TEAM_COMPACT_SPORT'] = '?controller=compact&action=teamcompactsport&username=$&pstatus=$&p=$'

	// 获取真人反水
	apis['GET_LIVE_REBET'] = 'compact/userlive?controller=compact&action=userlive&starttime=$&endtime=$&pstatus=$&p=$&orderby=$&sort=$'

	// 获取体育反水
	apis['GET_SPORT_REBET'] = 'compact/teamsalarysport?controller=compact&action=usersport&starttime=$&endtime=$&pstatus=$&p=$&username=$&orderby=$&sort=$'

	// 完善个人资料
	apis['MODIFY_PROFILE'] = '?controller=user&action=changename'

	// 获取第三方转账记录
	apis['GET_TRANSFER_RECORD'] = '?controller=report&action=fundreport&isgetdata=1&starttime=$&endtime=$&out_money=$&in_money=$&status=$&p=$'

	// 获取活动详情
	apis['GET_ACTIVITY_DETAIL'] = '?controller=activity&action=detail&aid=$'

	// 参与活动
	apis['PLAY_ACTIVITY'] = '?controller=activity&action=play&aid=$'

	// 获取下级列表
	apis['GET_TEAM_GROUP_LIST'] = 'compact/$?'

	// 取消订单
	apis['CANCEL_GAME_ORDER'] = '?controller=gameinfo&action=cancelgame&id=$&username=$&lottery=$&method=$&issue=$&backurld=$'

	// 彩票账变
	apis['LOTTERY_ACCOUNT_CHANGED'] = '?controller=gameinfo&action=lotteryaccountchanged&isgetdata=1&starttime=$&endtime=$&lotteryid=$&ordertype=$&username=$&p=$&modes=0&ischild=0'

	// 彩票契约分红
	apis['LOTTERY_DIVIDENDS_PINK'] = 'pink/index?sort=$&orderby=$&username=$&cycle_id=$&pay_status=$&p=$&pn=$&number=$'

	// 彩票契约查询分红发放状态
	apis['GET_LOTTERY_PINK_STATUS'] = 'pink/ajaxhub/countpink?1=1'

	// 发放分红
	apis['SEND_LOTTERY_PINK'] = 'pink/checkout?1=1'

	// 查看彩票契约分红
	apis['VIEW_LOTTERY_PINK'] = 'pink/ajaxhub/contract?userid=$'

	// 更新彩票契约分红
	apis['UPDATE_PINK_CONTRACT'] = 'pink/ajaxhub/checkrule?1=1'

	// 创建分红契约
	apis['CREATE_PINK_CONTRACT'] = 'pink/create?1=1'
	// 更新分红契约
	apis['MODIFY_PINK_CONTRACT'] = 'pink/update?1=1'
	

	return apis[key];

}



/**
* 打包请求对象
* @param  {[type]} key       		[请求地址Key]
* @param  {[type]} urlParam  		[URL资源参数，对象数组]
* @param  {[type]} postParam 		[对象/JSON串]
* @param  {[type]} method    		[请求方式 GET, POST, PUT, DELETE  ]
* @param  {[type]} loading    		[是否需要loading遮罩  ]
* @return {[type]}           		[请求对象]
*/
export function packageObsoleteReq(key, urlParam, postParam, method, loading) {

	var req = {};
	req.url = getObsoleteApi(key);
	req.method = method;

	if (!req.url) { return; }

	var paramMap = req.url.split("$");

	//URL参数组装
	if (paramMap.length > 1) {

		req.url = '';
		_.forEach(paramMap, function (val, index) {

			if (val === "") { return };

			req.url += val + (!_.isUndefined(urlParam[index]) ? String(urlParam[index]) || "" : "");

		});

	};

	// 所有URL参数来自传入
	if (getObsoleteApi(key) === '$') {
		req.url = urlParam;
	}

	//POST数据
	req.data = postParam ? postParam : undefined;


	// if (riskIobb) {

	// 	req.data.ioBB = $("#ioBB").val();

	// };

	//loading 遮罩
	req.loading = loading || false;

	//错误处理 (使用 payload._error_ 代替)
	// req.errorProcess = errorProcess || false;

	//本地缓存
	// if (cache) {

	// 	req.cache = {'key': key, 'expires': cache};

	// };

	//唯一标识
	return req;

}